var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lizard-form-bg"},[_c('div',{staticClass:"row lz-entry-row"},[_c('div',{staticClass:"col-lg-5 lz-entry-col"},[_c('ActivityForm',{attrs:{"activityType":_vm.activityType}})],1),_c('div',{staticClass:"col-lg-7 lz-entry-col"},[_c('ActivityList')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }